// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";
import {
  ChannelAsset,
  deserializeChannelAsset,
  serializeChannelAsset,
} from "./types/channelState";
import { LPPolicy } from "./types/liquidity";

// LPDepositInit starts an LP deposit. For CKB: ownerAddress is the FULL bech32m
// address, amount is shannons (>= 343 CKB), policy is required, and
// ethBeneficiary is required — it is the ETH address credited with ETH-pool
// shares when this cell's traded CKB is converted, written into the cell's
// on-chain data in the tx the owner signs and frozen there for the cell's life.
// For ETH: amount is wei, policy and ethBeneficiary are omitted. hub is the same
// hub id the swap UI passes to GetQuote (so the backend can notify the hub after
// the action completes).
@jsonObject()
export default class LPDepositInit extends PerunMessage {
  @jsonMember({
    deserializer: deserializeChannelAsset,
    serializer: serializeChannelAsset,
  })
  asset: ChannelAsset;
  @jsonMember(String) ownerAddress: string;
  @jsonMember(String) ethBeneficiary: string;
  @jsonMember(String) amount: string;
  @jsonMember(LPPolicy, { isRequired: false }) policy?: LPPolicy;
  @jsonMember(String) hub: string;

  constructor(
    asset: ChannelAsset,
    ownerAddress: string,
    amount: string,
    hub: string,
    policy?: LPPolicy,
    ethBeneficiary?: string,
  ) {
    super();
    this.asset = asset;
    this.ownerAddress = ownerAddress;
    this.amount = amount;
    this.hub = hub;
    this.policy = policy;
    // The backend ignores it for ETH deposits, and rejects an empty one when a
    // CKB deposit would create a cell.
    this.ethBeneficiary = ethBeneficiary ?? "";
  }

  messageType(): MessageType {
    return LPDepositInit;
  }

  messageTypeName(): MessageTypeName {
    return "LPDepositInit";
  }
}
